import { Schema } from 'effect';
import { SiteId } from './common.js';
/**
 * DTO schemas for the /admin/posts group: the write side of blog posts in
 * `sites/{site}/pages`. See http/config.ts for conventions - a body is
 * stricter than the stored-document schema, every field required and bounded.
 *
 * Posts are always html; the body is sanitised on read (see PageContent), so
 * it is bounded here, not cleaned.
 */
export const SiteParams = Schema.Struct({ siteId: SiteId });
export const PostParams = Schema.Struct({
    siteId: SiteId,
    slug: Schema.String
});
export const OkResponse = Schema.Struct({ message: Schema.String });
const Title = Schema.Trim.pipe(Schema.check(Schema.isMaxLength(200)));
// --- POST /admin/posts/:siteId -----------------------------------------------
/** A new draft. The slug is checked against isValidSlug by the backend. */
export const CreatePostBody = Schema.Struct({
    slug: Schema.String.pipe(Schema.check(Schema.isMaxLength(80))),
    title: Title.pipe(Schema.check(Schema.isMinLength(1)))
});
// --- PUT /admin/posts/:siteId/:slug ------------------------------------------
/**
 * The whole editable post. `status` is the target status, so publish and back
 * to draft are a save like any other.
 */
export const UpdatePostBody = Schema.Struct({
    title: Title,
    excerpt: Schema.Trim.pipe(Schema.check(Schema.isMaxLength(1000))),
    coverImage: Schema.String.pipe(Schema.check(Schema.isMaxLength(2048))),
    // Well inside Firestore's 1 MiB document limit.
    body: Schema.String.pipe(Schema.check(Schema.isMaxLength(500_000))),
    status: Schema.Literals(['draft', 'published'])
});
// --- problem ids --------------------------------------------------------------
/** Ids the admin UI maps to its own inline messages. */
export const PostProblem = {
    invalidSlug: 'problem.admin.posts.invalidslug',
    slugTaken: 'problem.admin.posts.slugtaken',
    notFound: 'problem.admin.posts.notfound',
    titleRequired: 'problem.admin.posts.titlerequired'
};
//# sourceMappingURL=posts.js.map